export const PALETTE_COLOR_DECLINATIONS_TONES = [50, 100, 200, 300, 400, 500, 600, 700] as const

export type PaletteColorDeclinationsTonesKeys = (typeof PALETTE_COLOR_DECLINATIONS_TONES)[number]
export type PaletteColorDeclinationsTones = Record<PaletteColorDeclinationsTonesKeys, string>
export type PaletteColorDeclinationToneValue = PaletteColorDeclinationsTones[PaletteColorDeclinationsTonesKeys]
